import { mapState, mapActions } from "vuex";

// import Loader from "@/components/Loader/Loader.vue";
import moment from 'moment';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Datepicker from "vuejs-datepicker";
import { platform } from "chart.js";

// import Toast from "@/components/Toast/Toast.vue";

export default {
    name: "CustomReport",
    components: { Treeselect,Datepicker },
    data() {
        return {
            dateRange: {
				startDate: moment().subtract(1,"months").format("YYYY-MM-DD"),
				endDate: moment().format("YYYY-MM-DD"),
			},
            // Loader Variable 
            viewReportAPILoader:false,  
            maxDate: new Date(),
			minDate: new Date(moment("2017-01-01")),
            isCreateReportTable:false,
            selectedReport:null,
            isDeleteModalOpen:false,
            reportName:'',
            reportNameErrorMessage:'',
            debounceTimer:null,
            flagError:false,
            platformList: [],
            multiple:false,
            isNotCustomReport: true,
            selectedReportType: null,
            isReportType:true,
            isEnabledPlatform:false,
            selectedPlatform:null,
            viewPlatformData:[],
            viewReportTypeData:[],
            viewSelectedMetricList:[],
            viewMetricList:[],
            isSelectedMetric:false,
            viewCreatedReportData:{},
            imageMapper:{
                d9e7f17809ff4695b28f538ae8f08b36:'amazon',
                e165604721bc4bf2b1538816285285f5:'flipkart'
            },

            isDeleteReportLoader:false,
            selectedMetric:null,
            selecteReportId:'',
            isPreviewButton:true,
            // Scheduling section 
            editScheduling: false,
            isScheduling:false,
            firstSchedule:false,
            selectedSchedulingInterval:null,
            selectedSchedulingFrequency:null,
            selectedTime:null,
            schedulingFrequencyList:[
                {
                    id:'daily',
                    label:'Daily'
                },
                {
                    id:'weekly',
                    label:'Weekly'
                },
                {
                    id:'monthly',
                    label:'Monthly'
                }
            ],
            schedulingIntervalList:{
                daily:[
                    {
                        id: 'hourly', label:'Hourly'
                    },
                    {
                        id:"once a day", label:'Once a day'
                    }
                ],
                weekly:[
                    { id: "Monday", label: "Monday" },
                    { id: "Tuesday", label: "Tuesday" },
                    { id: "Wednesday", label: "Wednesday" },
                    { id: "Thursday", label: "Thursday" },
                    { id: "Friday", label: "Friday" },
                    { id: "Saturday", label: "Saturday" },
                    { id: "Sunday", label: "Sunday" }
                ],
                monthly:[
                    { id: "1", label: "1" },
                    { id: "2", label: "2" },
                    { id: "3", label: "3" },
                    { id: "4", label: "4" },
                    { id: "5", label: "5" },
                    { id: "6", label: "6" },
                    { id: "7", label: "7" },
                    { id: "8", label: "8" },
                    { id: "9", label: "9" },
                    { id: "10", label: "10" },
                    { id: "11", label: "11" },
                    { id: "12", label: "12" },
                    { id: "13", label: "13" },
                    { id: "14", label: "14" },
                    { id: "15", label: "15" },
                    { id: "16", label: "16" },
                    { id: "17", label: "17" },
                    { id: "18", label: "18" },
                    { id: "19", label: "19" },
                    { id: "20", label: "20" },
                    { id: "21", label: "21" },
                    { id: "22", label: "22" },
                    { id: "23", label: "23" },
                    { id: "24", label: "24" },
                    { id: "25", label: "25" },
                    { id: "26", label: "26" },
                    { id: "27", label: "27" },
                    { id: "28", label: "28" },
                    { id: "29", label: "29" },
                    { id: "30", label: "30" },
                    { id: "31", label: "31" }
                ],                        
            },
            hourlyTimeList : [
                { id: 0, label: '12 AM' },
                { id: 60, label: '1 AM' },
                { id: 120, label: '2 AM' },
                { id: 180, label: '3 AM' },
                { id: 240, label: '4 AM' },
                { id: 300, label: '5 AM' },
                { id: 360, label: '6 AM' },
                { id: 420, label: '7 AM' },
                { id: 480, label: '8 AM' },
                { id: 540, label: '9 AM' },
                { id: 600, label: '10 AM' },
                { id: 660, label: '11 AM' },
                { id: 720, label: '12 PM' },
                { id: 780, label: '1 PM' },
                { id: 840, label: '2 PM' },
                { id: 900, label: '3 PM' },
                { id: 960, label: '4 PM' },
                { id: 1020, label: '5 PM' },
                { id: 1080, label: '6 PM' },
                { id: 1140, label: '7 PM' },
                { id: 1200, label: '8 PM' },
                { id: 1260, label: '9 PM' },
                { id: 1320, label: '10 PM' },
                { id: 1380, label: '11 PM' }
            ],  
            schedulingEmailList:[],
            userEmail:'',
            schedulingEmailError: false,
            schedulingNumberList: [],
            userNumber:'',
            schedulingPhoneError:false,
            // update report 
            isEditReportLoader:false, 
            isEdit:false,
        }
    },
    mounted() {
        this.dataAPIs();
    },
    methods: {
        showCreateModal (){
            this.isEdit=false;
            this.reportName = '',
            this.isPreviewButton = true
            this.isNotCustomReport = true
            this.selectedPlatform = null
            this.selectedReportType = null
            this.selectedMetric = null
            this.viewMetricList = [];
            this.viewSelectedMetricList = [];
            this.isCreateReportTable = true;
            this.isEnabledPlatform = false;
            this.schedulingEmailList = [];
            this.schedulingPhoneError = [];
            this.selectedSchedulingInterval=null;
            this.selectedSchedulingFrequenc=null;
            this.selectedTime=null;
            this.editScheduling = false;
        },

        dataAPIs(){
            this.getCreatedReportTableData();
            this.getPlatformData();
        },

        showDeletePopup(reportId){
            this.selecteReportId = '';
            this.selecteReportId = reportId;
            this.isDeleteModalOpen = true
        },

        handleInput() {
            if(this.isEdit){
                return false;
            }
            if(!this.reportName.length){
                this.flagError = true;
                this.reportNameErrorMessage = "Please Enter Report Name"
                return false;
            }
            clearTimeout(this.debounceTimer);
                if (this.reportName.trim() === '') return;
                this.debounceTimer = setTimeout(() => {
                this.checkReportName(this.reportName);
            }, 500); 
        },
        // remove metric section 
        removeAllSelectedMetric(){
            this.selectedMetric = [];
        },

        removeSelectedMetric(metric,idx){
           this.selectedMetric = this.selectedMetric.filter(element=>element!==metric.id)
           this.processSelecteMetric();

        },

         // Scheduling section 
        toggleScheduling(data){
            if(data.first_schedule && !data.scheduling){
                this.editScheduling= true
                this.editReport(data);
                this.isCreateReportTable = true
                this.isScheduling = true
                return false;
            }
            const url = "/api/v2/custom_report/edit_schedule"
            const payload = {
               'id' : data.report_id,
                'isScheduled' :  data.scheduling,
                'first_schedule': data.first_schedule,
            }
            this.$http.post(url,payload).then((res)=>{
                this.dataAPIs();
                this.$bvToast.toast(`Updated`, {
                    title: "Weavr Sense",
                    variant: "success",
                    toaster: "b-toaster-top-center",
                    autoHideDelay: 3000
                });
                if ($.fn.DataTable.isDataTable('#capaignDataTable')) {
                    $('#capaignDataTable').DataTable().destroy();
                }
            }).catch(err=>(console.log("err")))
        },

        addEmail(isEnterButton=true){
            let email = this.userEmail.trim();
            if(isEnterButton){
                if (event.key !== "Enter") {
                    return false;
                }
            }

            if(!email.length){
                return false;
            }

            if(!this.validEmail(email)){
                alert(`Please enter a valid email (${email})`);
                return false;
            }
            if (!this.schedulingEmailList.includes(email)) {
                this.schedulingEmailList.push(email);

            } else {
                alert(`email ${email} is already added. Please enter a different email.`);
                return false;
            }
            this.userEmail = ''
            return true
        },

        removeEmail(email){
            this.schedulingEmailList.splice(email, 1);

        },

        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        addNumber(isEnterButton = true){
            let number = this.userNumber.trim();
            if(isEnterButton){
                if (event.key !== "Enter") {
                    return false;
                }
            }
            if(!number.length){
                return false;
            }
            if(!this.validNumber(number)){
                alert(`Please enter a valid whatsapp number (${number})`);
                return false;
            }
            if (!this.schedulingNumberList.includes(number)) {
                this.schedulingNumberList.push('+91'+number);

            } else {
                alert(`Number ${number} is already added. Please enter a different whatsapp number.`);
                return false
            }
            this.userNumber = ''
            return true
        },
        removeNumber(number){
            this.schedulingNumberList.splice(number, 1);
        },

        validNumber(number) {
            var re = /^(\+\d{1,3}[- ]?)?\d{10}$/
            return re.test(number);
        },

        // edit section 
        editReport(data){
            this.selecteReportId =''
            this.flagError = false;
            this.isEditReportLoader = true
            this.isEdit = true
            this.selectedReportType = data.ref_id
            this.selecteReportId = data.report_id
            this.firstSchedule = data.first_schedule

            const url = "/api/v2/custom_report/edit_report?id="+data.report_id
            this.$http.get(url).then(res=>{
                this.isEditReportLoader = false
                const temp = res.data.data
                if(temp){
                    this.reportName = temp.report_name
                    this.selectedPlatform = temp.platforms
                    this.getReportType(true);
                    this.selectedReportType = temp.ref_id
                    // this.firstSchedule = temp.first_schedule
                    this.selectedMetric = temp.metrics.children.map(element=>(element.id))
                    if(temp.isScheduled){
                        this.isScheduling = temp.isScheduled
                        this.selectedSchedulingInterval = temp.schedule_data?.interval[0]
                        this.selectedSchedulingFrequency = temp.schedule_data?.frequency
                        if(this.selectedSchedulingInterval!='hourly'){
                            this.selectedTime= Number(temp.schedule_data?.time[0])
                        }
                        this.schedulingNumberList = temp.schedule_data?.phone
                        this.schedulingEmailList = temp.schedule_data.email
                    }
                }
                
                this.isReportType = true
                this.isPreviewButton = false
                this.isEnabledPlatform = true
                this.isCreateReportTable = true

            }).catch(err=>{
                this.isEditReportLoader = false
                this.$bvToast.toast(`Technical Error!`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-top-center",
                    autoHideDelay: 3000
                });
            })
        //    this.isCreateReportTable= true; 
        //    this.reportName = data.report_name
        //    this.selectedPlatform = data.platforms
        //    this.selectedReportType = data.report_id
        },

        checkReportName (){
            const url = "/api/v2/custom_report/create"
            const payload={
                "level":"name_check",
                "name": this.reportName
            } 
            this.$http.post(url,payload).then(res=>{
                this.flagError = res?.body?.data[0].exists
                this.reportNameErrorMessage = "Report already exists"
            }).catch(err=>{

            })
        },
        
        deleteReport(){
            const url = "/api/v2/custom_report/view_report?id="+this.selecteReportId
            this.isDeleteReportLoader = true
            const payload={
                id: this.selecteReportId
            }
            this.$http.delete(url).then((res)=>{
                this.isDeleteReportLoader = false
                this.isDeleteModalOpen = false
                if ($.fn.DataTable.isDataTable('#capaignDataTable')) {
                    $('#capaignDataTable').DataTable().destroy();
                }
                location.reload();
                // this.getCreatedReportTableData();
            }).catch(err=>{console.log("delete ")})
        },

        getPlatformData(){
            const url = "/api/v2/custom_report/create"
            const payload = {
                "level": "channel",
            }
            this.$http.post(url,payload).then(res=>{
                this.viewPlatformData = res.data.data.map((data)=>({id:data.key,label:data.label}));
            }).catch(err=>{
                console.log(err)
            })
        },

        getReportType(isUpdate=false){
            const url = "/api/v2/custom_report/create"
            const payload = {
                "level": "type",
                "platform_id": this.selectedPlatform
            }
            if(this.selectedReportType=='new') {payload.platform_id = [this.selectedPlatform].flat();}
            this.isReportType = true
            if(!this.selectedPlatform.length){
                this.selectedReportType = null
                return false
            }
            this.$http.post(url,payload).then(res=>{
                this.viewReportTypeData=res.data.data.map(data=>({id:data.key,label:data.value}))
                this.viewReportTypeData.push({id:'new', label:'Custom Report'})
                if(this.viewReportTypeData.length){
                    this.isReportType = false
                }
                if(isUpdate)  
                {
                    this.isReportType = true
                }
                if(this.selectedReportType.length){
                    this.getSelectedReportMetricData();
                }
            }).catch(err=>{console.log("err")});
        },

        getSelectedReportMetricData(){
            this.isPreviewButton = false
            if(this.selectedReportType=='new'){
                this.isNotCustomReport = false;
                if(!this.isEdit){
                    this.selectedMetric = []
                }
            }
            else{this.isNotCustomReport = true}
            const url = "/api/v2/custom_report/create"
            let payload = {
                "level": "metrics",
                "platform_id": this.selectedPlatform,
                "report_id": this.selectedReportType
            }
            if(this.selectedReportType=='new') {payload.platform_id = [this.selectedPlatform].flat();}
            // this.isSelectedMetric = true
            this.$http.post(url,payload).then(res=>{
                this.viewMetricList = res.data.data
                if(this.selectedReportType == 'new'){
                    this.selectedPlatform = typeof(this.selectedPlatform)=='string'?[this.selectedPlatform]:this.selectedPlatform
                    this.isSelectedMetric = false
                    this.selectedMetric = []
                    this.selectedMetric = this.selectedPlatform[0]=='d9e7f17809ff4695b28f538ae8f08b36'?['campaignName','campaignId']:['CampaignName'];
                    this.viewSelectedMetricList = [{
                        id: this.selectedPlatform,
                        isDisabled: false,
                        label: this.viewMetricList[0].label,
                        children:[]
                    }]
                    if(this.isEdit){
                        this.processSelecteMetric();
                    }
                }
                else{
                    if(this.isEdit){
                        this.isSelectedMetric = true
                    }
                    this.selectedMetric = this.viewMetricList[0].children.map(data=>(data.id))
                    this.viewSelectedMetricList = res.data.data
                }
                // this.selectedMetric = this.viewSelectedMetric.flatMap(item=>[item.id,...item.children.map(child=>child.id)]);
            }).catch(err=>{console.log("err")});
        },

       

        getCreatedReportTableData(){
            const url = "/api/v2/custom_report/view_report_list"
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD")
            }
            if ($.fn.DataTable.isDataTable('#campaignDataTable')) {
                $('#campaignDataTable').DataTable().destroy();
            }
            this.viewCreatedReportData  = {}
            this.viewReportAPILoader = true
            
            this.$http.post(url,payload).then(res=>{
                this.viewCreatedReportData =res.data.data
                this.$nextTick(() => {
                    this.processTable("#campaignDataTable");
                });
                this.viewReportAPILoader = false
            }).catch(err=>{                
                this.viewReportAPILoader = false
                console.log("err")
            });
        },

        handlePreviewButton(){ // this functin written for preview button toggle edit aur created report
            if(this.isEdit){
                this.updateReport();
                this.createReport();
            }
            else{
                this.createReport()
            }
        },

        updateReport(){
            if(!this.reportName.length){
                this.flagError = true;
                this.reportNameErrorMessage = "Please Enter Report Name"
                return false;
            }
            let url = "/api/v2/custom_report/edit_report"
            let payload = {
                "report_name" : this.reportName,
                "report_id": this.selecteReportId,
                "platforms" : this.selectedPlatform.flat(),
                "isDefault" : true,
                "ref_id" : this.selectedReportType,
                "view_range" : "daily",
                'isScheduled' : this.isScheduling,
            }
            if(this.isScheduling){
                payload.first_schedule = this.firstSchedule
                if(!this.userEmail.length && !this.schedulingEmailList.length){
                    alert("Please Enter Email")
                    return false 
                }
                else{
                    // if()
                    if(this.userEmail.length) this.addEmail(false);     
                }
                
                if(!this.userNumber.length && !this.schedulingNumberList.length){
                    alert("Please Enter Whatsapp Number")
                    return false
                }
                else{
                    if(this.userNumber.length) this.addNumber(false);
                }
                
                payload.frequency = this.selectedSchedulingFrequency,
                payload.emails=this.schedulingEmailList,
                payload.whatsapp =this.schedulingNumberList
                if(this.selectedSchedulingFrequency=='daily'){
                    if(this.selectedSchedulingInterval =='hourly'){
                        payload.send_times = this.hourlyTimeList.map(data=>(Number(data.id)))
                    }
                    else if(this.selectedSchedulingInterval =='once a day'){
                        payload.send_times = [Number(this.selectedTime)]
                    }
                }
                else if(this.selectedSchedulingFrequency=='weekly'){
                    payload.days= [this.selectedSchedulingInterval]
                    payload.send_times = [Number(this.selectedTime)]
    
                }
                else if(this.selectedSchedulingFrequency=='monthly'){
                    payload.dates = [this.selectedSchedulingInterval]
                    payload.send_times = [Number(this.selectedTime)]
                }
            }
            if(this.selectedReportType==='new'){
                payload.isDefault = false,
                payload.metrics= this.mapKeyValuePairOfMetric()
            }
            this.$http.post(url,payload).then(res=>{

                // this.$router.push('/custom-report/preview/'+this.selecteReportId)
            }).catch(err=>{console.log("err")});
        },

        createReport(){
            if(!this.reportName.length){
                this.flagError = true;
                this.reportNameErrorMessage = "Please Enter Report Name"
                return false;
            }
            // this.selectedPlatform = this.selectedPlatform.flat()
            let url = "/api/v2/custom_report/data_save"
            let payload = {
                "report_name" : this.reportName,
                "channel" : typeof(this.selectedPlatform)=='string'?[this.selectedPlatform]:this.selectedPlatform,
                "isDefault" : true,
                "ref_id" : this.selectedReportType,
                "view_range" : "daily",
                "metrics" : this.mapKeyValuePairOfMetric(),
                'isScheduled': this.isScheduling,
            }
            if(this.isEdit){
                payload.first_schedule = this.firstSchedule;
                payload.report_id = this.selecteReportId;
            }
            if(this.editScheduling){
                payload.first_schedule = this.firstSchedule;
            }
            if(this.isScheduling){
                if(!this.userEmail.length && !this.schedulingEmailList.length){
                    alert("Please Enter Email")
                    return false 
                }
                else{
                    // if()
                    if(this.userEmail.length) {
                        if(!this.addEmail(false)){
                            return false;
                        }
                    };     
                }

                if(!this.userNumber.length && !this.schedulingNumberList.length){
                    alert("Please Enter Whatsapp Number")
                    return false
                }
                else{
                    if(this.userNumber.length) this.addNumber(false);
                }

                if(!this.selectedSchedulingFrequency){
                    alert("Please Select Frequency");
                    return false
                }

                if(!this.selectedSchedulingInterval){
                    alert("Please Select Interval")
                    return false
                }

                if(this.selectedSchedulingInterval!='hourly'&&!this.selectedTime){
                    alert("Please Select Time")
                    return false
                }
                payload.frequency = this.selectedSchedulingFrequency,
                payload.emails=this.schedulingEmailList,
                payload.whatsapp =this.schedulingNumberList
                if(this.selectedSchedulingFrequency=='daily'){
                    if(this.selectedSchedulingInterval =='hourly'){
                        payload.send_times = this.hourlyTimeList.map(data=>(Number(data.id)))
                    }
                    else if(this.selectedSchedulingInterval =='once a day'){
                        payload.send_times = [Number(this.selectedTime)]
                    }
                }
                else if(this.selectedSchedulingFrequency=='weekly'){
                    payload.days= [this.selectedSchedulingInterval]
                    payload.send_times = [Number(this.selectedTime)]
    
                }
                else if(this.selectedSchedulingFrequency=='monthly'){
                    payload.dates = [this.selectedSchedulingInterval]
                    payload.send_times = [Number(this.selectedTime)]
                }
            }
           
            
            if(this.selectedReportType==='new'){
                payload.isDefault = false
                // payload.metrics = this.mapKeyValuePairOfMetric()
            }
            this.$http.post(url,payload).then(res=>{
                if(this.editScheduling){
                    location.reload();
                    return false;
                }
                if(this.isEdit){
                    this.$router.push('/custom-report/update/'+res.body.data.id)
                }
                else{
                    this.$router.push('/custom-report/preview/'+res.body.data.id)
                }
            }).catch(err=>{console.log("err")});
        },
        
        processSelecteMetric(){  // it is for show the selected metric in the model
            let temp = []
            this.viewMetricList[0].children.forEach(element => {
                if(this.selectedMetric.includes(element.id)){
                    temp.push(element)
                }
            }); 
            this.viewSelectedMetricList[0].children = temp 
        },

        mapKeyValuePairOfMetric() // it is for convert selected metric in the key value pair for send in payload
        { 
            let temp = []
            this.selectedPlatform = typeof(this.selectedPlatform)=='string'?[this.selectedPlatform]:this.selectedPlatform
            this.viewMetricList.forEach(element => {
                if(element.id== this.selectedPlatform[0]){
                    element.children.forEach((element)=>{
                        if(this.selectedMetric.includes(element.id)){
                            temp.push({key:element.id, value:element.label})
                        }
                    })
                }
            }); 
            return temp;
        },
        
      
        processTable(id) {
            $(id).DataTable().destroy();
            $(id).DataTable({
              searching: true,
              info: true,
              ordering: true,
              order: [],
              columnDefs: [
                {
                  targets: 0,
                  className: "min-width-column",
                },
              ],
              initComplete: function () {
                $(id).wrap(
                  "<div style='overflow:auto; width:100%;position:relative;'></div>"
                );
              },
              language: {
                search: "",
                searchPlaceholder: "Search...",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
              },
            });
            $(id + "_filter > label").append(
              `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
            );
        },
    }
}